import React from 'react';

import CheckIcon from '../Icon/CheckIcon';

import styles from './FeatureItem.module.css';

interface FeatureItemProps {
  content: string
}

const FeatureItem = (props: FeatureItemProps) => {
  return (
    <div className={styles.root}>
      <span className={styles.icon}>
        <CheckIcon/>
      </span>
      <span className={styles.content} data-manabie="feature-content">
        {props.content}
      </span>
    </div>
  );
};

export default FeatureItem;